import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
  Col,
  Row,
  Container,
  Form,
  Dropdown,
  InputGroup,
  Alert,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TwitterPicker } from "react-color";
import TextLoading from "../../global/TextLoading";

// API
import {
  GetColorsPalette,
  DeleteAttendanceCategory,
  UpdateAttendanceCategory,
  CreateAttendanceCategory,
  GetClassDays,
} from "../../../api/class";

const daysKey = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export default function ModalAssistanceCategories(props) {
  const [t] = useTranslation(["class", "global"]);
  const [categories, setCategories] = useState(props.categoriesAttendance); //TODO: replace with props.attendanceToConfirmed
  const [isSaving, setIsSaving] = useState(false);
  const [colors, setColors] = useState([]);
  const [categoriesToDelete, setCategoriesToDelete] = useState([]);
  const [classDays, setClassDays] = useState([]);
  const [error, setError] = useState(false);

  const [pendingRequests, setPendingRequests] = useState(0);

  const teplateCategory = {
    class_id: props.classId,
    id: null,
    name: "",
    color: "FEDAE3",
    input_type: "checkbox",
    daysWeek: [
      { day: "monday", value: false },
      { day: "tuesday", value: false },
      { day: "wednesday", value: false },
      { day: "thursday", value: false },
      { day: "friday", value: false },
      { day: "saturday", value: false },
      { day: "sunday", value: false },
    ],
    colorPiker: false,
    flag: "0",
  };

  const heightWindow = window.innerHeight;
  const heightConteiner = heightWindow - 240;

  useEffect(() => {
    getColors();
    getClassDays();
  }, []);

  const toggleSketchPicker = (index) => {
    let updatedCategories = [...categories];
    updatedCategories[index].colorPiker = !updatedCategories[index].colorPiker;
    setCategories(updatedCategories);
  };

  /**
   * Get color palette
   */
  const getColors = () => {
    GetColorsPalette().then((result) => {
      let colors = result.data;
      if (colors) {
        setColors(colors);
      }
    });
  };

  const getClassDays = () => {
    const payload = {
      class_id: props.classId,
    };
    GetClassDays(payload).then((result) => {
      if (result.status) {
        const daysActive = {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
        };
        let scheduleList = result.data.schedule;

        for (const schedule of scheduleList) {
          for (const key of daysKey) {
            if (schedule[key]) {
              daysActive[key] = true;
            }
          }
        }
        setClassDays(daysActive);
      }
    });
  };

  const addNewCategory = () => {
    let updatedCategories = [...categories];
    updatedCategories.push(teplateCategory);
    setCategories(updatedCategories);
  };

  const saveChanges = () => {
    setIsSaving(true);
    // filtrar categorias con id null
    const newCategories = categories.filter((category) => category.id == null);
    // filtrar categorias modificadas
    const modifiedCategories = categories.filter(
      (category) => category.touched,
    );
    // TODO: en un futuro esto debe gestionarse en un solo request
    if (categoriesToDelete.length > 0) {
      setPendingRequests((prev) => prev + 1);
      deleteCaegories(categoriesToDelete);
    }
    if (modifiedCategories.length > 0) {
      setPendingRequests((prev) => prev + 1);
      updateCategories(modifiedCategories);
    }
    if (newCategories.length > 0) {
      setPendingRequests((prev) => prev + 1);
      createCategories(newCategories);
    }
    if (
      categoriesToDelete.length === 0 &&
      modifiedCategories.length === 0 &&
      newCategories.length === 0
    ) {
      props.onClose();
    }
  };

  const deleteCaegories = (categoriesToDelete) => {
    const payload = {
      attendance_category_ids: categoriesToDelete,
    };

    DeleteAttendanceCategory(payload).then(() => {
      setPendingRequests((prev) => prev - 1);
    });
  };

  const updateCategories = (modifiedCategories) => {
    const categoriasPayload = modifiedCategories.map((category) => {
      return {
        id: category.id,
        class_id: category.class_id,
        name: category.name,
        color: category.color,
        input_type: category.input_type,
        days_of_the_week: formatAttendanceDays(category.daysWeek),
      };
    });
    const payload = {
      attendance_categories: categoriasPayload,
    };
    UpdateAttendanceCategory(payload).then((result) => {
      if (result.status) {
        setPendingRequests((prev) => prev - 1);
      } else {
        setIsSaving(false);
        setError(result.description);
      }
      setPendingRequests((prev) => prev - 1);
    });
  };

  const createCategories = (newCategories) => {
    const categoriasPayload = newCategories.map((category) => {
      return {
        class_id: props.classId,
        name: category.name,
        color: category.color,
        input_type: category.input_type,
        days_of_the_week: formatAttendanceDays(category.daysWeek),
      };
    });
    const payload = {
      attendance_categories: categoriasPayload,
    };
    CreateAttendanceCategory(payload).then((result) => {
      if (result.status) {
        setPendingRequests((prev) => prev - 1);
      } else {
        setIsSaving(false);
        setError(result.description);
      }
    });
  };

  const formatAttendanceDays = (attendanceDays) => {
    let weekDays = {};
    attendanceDays.forEach((day) => {
      weekDays[day.day] = day.value ? "1" : "0";
    });
    return weekDays;
  };

  useEffect(() => {
    if (pendingRequests === 0 && isSaving) {
      props.updateList();
      props.onClose();
    }
  }, [pendingRequests]);

  return (
    <Modal show={props.showModalAssistanceCategories}>
      <Modal.Header>
        <Modal.Title>
          {t("class:modalAttendanceCategories.title")}
          <span>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="tooltip-group">
                  {t("class:modalAttendanceCategories.titleMenssage")}
                </Tooltip>
              }
            >
              <i
                className="bi bi-info-circle-fill ms-2"
                id="infoAssistanceCategories"
                role="button"
                style={{
                  fontSize: "16px",
                }}
              />
            </OverlayTrigger>
          </span>
          <Button
            id="addAssistanceCategory"
            variant="secondary"
            style={{ right: "15px", position: "absolute", marginTop: "4px" }}
            onClick={() => addNewCategory()}
          >
            <i
              className="bi bi-plus"
              role="button"
              style={{
                fontSize: "16px",
                verticalAlign: "middle",
              }}
            />
            {t("class:modalAttendanceCategories.addCategory")}
          </Button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container
          style={{ maxHeight: heightConteiner + "px", overflow: "auto" }}
        >
          {categories.map((category, index) => {
            const isDefaultCategory = category.flag == 1 || category.id == 1;
            return (
              <>
                <Form.Label
                  key={index}
                  style={{
                    marginLeft: "-10px",
                    marginBottom: "0px",
                  }}
                >
                  {t("class:modalAttendanceCategories.category") +
                    " " +
                    (index + 1)}
                </Form.Label>
                <Row
                  style={{ border: "solid 1px #dee2e6", borderRadius: "5px" }}
                  className="pt-3 mb-3"
                >
                  {/* Name and Color */}
                  <Col sm={12} md={6} xl={6}>
                    <Form.Label
                      style={{
                        marginBottom: "0px",
                      }}
                    >
                      {t("class:modalAttendanceCategories.categoryName")}
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        id={"categoryName-" + index}
                        type="text"
                        className="capitalize-text"
                        defaultValue={category.name}
                        onChange={(event) => {
                          let updatedCategories = [...categories];
                          updatedCategories[index].name = event.target.value;
                          if (updatedCategories[index].id) {
                            updatedCategories[index].touched = true;
                          }
                          setCategories(updatedCategories);
                        }}
                        disabled={isDefaultCategory}
                      />
                      <InputGroup.Text
                        id={"colorPicker-" + index}
                        role="button"
                        style={
                          isDefaultCategory
                            ? {
                                background: "#" + category.color,
                                width: "35px",
                                cursor: "not-allowed",
                              }
                            : {
                                background: "#" + category.color,
                                width: "35px",
                              }
                        }
                        onClick={() =>
                          isDefaultCategory ? null : toggleSketchPicker(index)
                        }
                        disabled={isDefaultCategory}
                      ></InputGroup.Text>
                    </InputGroup>
                    {category.colorPiker && (
                      <div style={{ position: "fixed", zIndex: 1 }}>
                        <TwitterPicker
                          id={"colorPickerAttendanceCategory-" + index}
                          width="207px"
                          triangle="top-right"
                          colors={colors}
                          color={"#" + category.color}
                          onChangeComplete={(color) => {
                            let updatedCategories = [...categories];
                            updatedCategories[index].color = color.hex.replace(
                              "#",
                              "",
                            );
                            if (updatedCategories[index].id) {
                              updatedCategories[index].touched = true;
                            }
                            updatedCategories[index].colorPiker = false;
                            setCategories(updatedCategories);
                          }}
                        />
                      </div>
                    )}
                  </Col>
                  {/* Input Type */}
                  <Col sm={12} md={6} xl={6}>
                    <Form.Label
                      style={{
                        marginBottom: "0px",
                      }}
                    >
                      {t("class:modalAttendanceCategories.inputType")}
                    </Form.Label>
                    <Dropdown>
                      <Dropdown.Toggle
                        id={"typeInput-" + index}
                        variant="outline-secondary"
                        style={{
                          width: "100%",
                          textAlign: "left",
                          height: "38px",
                          borderColor: "#dee2e6",
                        }}
                        disabled={isDefaultCategory}
                      >
                        {category.input_type == "checkbox"
                          ? t("class:modalAttendanceCategories.typeCheckbox")
                          : t("class:modalAttendanceCategories.typeText")}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          id={"typeCheckbox-" + index}
                          key="checkbox"
                          onClick={() => {
                            let updatedCategories = [...categories];
                            updatedCategories[index].input_type = "checkbox";
                            if (updatedCategories[index].id) {
                              updatedCategories[index].touched = true;
                            }
                            setCategories(updatedCategories);
                          }}
                        >
                          {t("class:modalAttendanceCategories.typeCheckbox")}
                        </Dropdown.Item>
                        <Dropdown.Item
                          id={"typeText-" + index}
                          key="text"
                          onClick={() => {
                            let updatedCategories = [...categories];
                            updatedCategories[index].input_type = "text";
                            if (updatedCategories[index].id) {
                              updatedCategories[index].touched = true;
                            }
                            setCategories(updatedCategories);
                          }}
                        >
                          {t("class:modalAttendanceCategories.typeText")}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    {category.input_type == "text" && (
                      <Form.Text className="text-muted">
                        {t("class:modalAttendanceCategories.typeTextInfo")}
                      </Form.Text>
                    )}
                  </Col>
                  {/* Days of the week */}
                  <Col sm={12} md={12} xl={12} className="mt-3">
                    <Form.Label
                      style={{
                        marginBottom: "0px",
                      }}
                    >
                      {t("class:modalAttendanceCategories.daysOfWeek")}
                    </Form.Label>
                    <Row>
                      {daysKey.map((day, dayIndex) => {
                        return (
                          <Col xs={1} sm={1} md={1} xl={1} key={dayIndex}>
                            <Form.Check
                              id={day + "-" + index + "-" + dayIndex}
                              className="big-checkbox"
                              type="checkbox"
                              style={{ width: "24px", height: "24px" }}
                              checked={category.daysWeek[dayIndex].value}
                              disabled={!classDays[day] || isDefaultCategory}
                              onChange={() => {
                                let updatedCategories = [...categories];
                                updatedCategories[index].daysWeek[
                                  dayIndex
                                ].value =
                                  !updatedCategories[index].daysWeek[dayIndex]
                                    .value;
                                if (updatedCategories[index].id) {
                                  updatedCategories[index].touched = true;
                                }
                                setCategories(updatedCategories);
                              }}
                            />
                          </Col>
                        );
                      })}
                      <Col xs={5} sm={5} md={5} xl={5}>
                        {category.id != 1 && category.flag == "0" && (
                          <Button
                            id={"btnRemoveCategory-" + index}
                            variant="outline-danger"
                            disabled={isSaving}
                            className="float-end"
                            onClick={() => {
                              if (category.id) {
                                setCategoriesToDelete([
                                  ...categoriesToDelete,
                                  category.id,
                                ]);
                              }
                              let updatedCategories = [...categories];
                              updatedCategories.splice(index, 1);
                              setCategories(updatedCategories);
                            }}
                          >
                            <i className="bi bi-trash" />
                            {t("class:modalAttendanceCategories.remove")}
                          </Button>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      {daysKey.map((day, indexkey) => {
                        return (
                          <Col
                            xs={1}
                            sm={1}
                            md={1}
                            xl={1}
                            key={indexkey}
                            className="text-center"
                          >
                            <span>
                              {t("class:modalAttendanceCategories." + day)}
                            </span>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </>
            );
          })}
        </Container>
        {error && (
          <Alert className="mt-2 mb-0" variant="danger">
            {error}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          id="btnCancel"
          variant="secondary"
          onClick={() => props.onClose()}
        >
          {t("global:buttons.cancel")}
        </Button>
        <Button
          id="btnAccept"
          variant="primary"
          onClick={() => saveChanges()}
          disabled={isSaving}
        >
          {isSaving ? (
            <TextLoading text={t("global:buttons.saving")} variant="light" />
          ) : (
            t("global:buttons.save")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ModalAssistanceCategories.propTypes = {
  showModalAssistanceCategories: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  categoriesAttendance: PropTypes.array.isRequired,
  classId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  updateList: PropTypes.func.isRequired,
};
